import { RightEnum } from '@core/models/rights.model';
import { BtnGroupItem } from '@shared/components';

export interface DialogLabels {
  itemLabel: string;
  selectAllErrorTitle: string;
  selectAllErrorSubtitle: string;
  selectAllValidateErrorBtn: string;
  selectAllCancelWarningBtn: string;
  selectAllValidateWarningBtn: string;
  selectAllWarningSubtitle: string;
}

export interface TreeListColumn {
  id: string;
  caption: string;
  translatePrefix?: string;
  cellTemplate?: string;
  alignment?: 'left' | 'right' | 'center';
  width?: number;
  minWidth?: number;
  sortIndex?: number;
  sortOrder?: 'asc' | 'desc';
  allowSorting?: boolean;
  editable?: boolean;
  exportable?: boolean;
  groupIndex?: number;
  cssClass?: string;
  calculateCellValue?: (rowData: any) => string | null;
  visible?: (rowData: any) => boolean;
}
export interface ActionsBarOptions {
  label: string;
  width: string;
  slice: number;
}

export interface TreeListPagination {
  enabled?: boolean;
  pageIndex?: number;
  pageSize?: number;
}
export interface OrderItemsResultInfo {
  seatCount: number;
  totalAmount: number;
  ordersCount: number;
  totalCount: number;
}

export interface TreeListAction {
  label?: string;
  icon?: string;
  class?: string;
  wrapperClass?: string;
  contextLabel?: (rowData: any) => string;
  selectionLabel?: (selection: any[]) => string;
  command: (rowData: any) => void;
  allItemsCommand?: (selection: any) => void;
  disabled?: boolean;
  hidden?: (rowData: any) => boolean;
  allItemsHidden?: (rowData: any) => boolean;
  allItemsIgnoreHidden?: boolean;
  multiple?: boolean;
  groupItems?: (rowData: any) => BtnGroupItem[];
  dataCy?: string;
  rights?: RightEnum[];
  tooltipValue?: string;
}
export const defaultTreeOptions = {
  remoteOperations: {
    groupPaging: false,
    paging: false,
    filtering: true,
    sorting: true,
    grouping: true,
  },
  pagination: {
    enabled: false,
    pageSize: 25,
    displayMode: 'compact',
    showInfo: true,
    showPageSizeSelector: true,
    allowedPageSizes: [25, 50, 100, 0],
    infoText: 'shared.tablePaginationInfoText',
  },
  loadPanel: {
    enabled: false,
  },
  noDataText: 'Aucun résultat.',
  translatePrefix: null,
  columnResizing: true,
  columnResizingMode: 'nextColumn',
  columnAutoWidth: false,
  selectionMode: 'multiple',
  styleClass: [],
};

export const MAX_ROWS_COUNT_WARNING = 170;
export const MAX_ROWS_COUNT_ERROR = 500;
